// extracted by mini-css-extract-plugin
module.exports = {"input":"gdlInput_input_2WKd2"};